/** @typedef {import('./ServiceProviderUser.svc')} Types */
//
export class ServiceProviderUser {
	constructor($http, API, PUBLIC_KEY) {
		'ngInject';
		this.http = $http;
		this.path = `${API}/v1/serviceProviderUser`;
		this.PUBLIC_KEY = PUBLIC_KEY;
	}

	/**
	 * @deprecated Superseded by Auth0. Retained for the deprecated user.login state; no live path calls this.
	 * @param {Types.PostLoginParams} params
	 */
	postLogin(params) {
		const config = {headers: {Auth: this.PUBLIC_KEY}};
		return this.http.post(`${this.path}/login`, params, config);
	}

	/** @param {Types.GetAllUsersByProviderParams} params */
	getAllUsersByProvider(params, cache = false) {
		return this.http.get(`${this.path}/allUsersByProvider`, {params, cache});
	}

	/** @param {Types.DoLogoutParams} params */
	doLogout(params) {
		return this.http.post(`${this.path}/logout`, params);
	}

	/** @param {Types.ResetPasswordParams} params */
	resetPassword(params) {
		return this.http.post(`${this.path}/resetpassword`, params);
	}

	/** @param {Types.GetForgotPasswordForEmailParams} params */
	getForgotPasswordForEmail(params, cache = false) {
		const headers = {Auth: this.PUBLIC_KEY};
		return this.http.get(`${this.path}/forgotPasswordForEmail`, {params, cache, headers});
	}

	/** @param {Types.GetUserDetailsByForgotTokenParams} params */
	getUserDetailsByForgotToken(params, cache = false) {
		const headers = {Auth: this.PUBLIC_KEY};
		return this.http.get(`${this.path}/userDetailsByForgotToken`, {params, cache, headers});
	}

	/** @param {Types.ChangePasswordWithForgotTokenParams} params */
	changePasswordWithForgotToken(params) {
		const config = {headers: {Auth: this.PUBLIC_KEY}};
		return this.http.post(`${this.path}/changePasswordWithForgotToken`, params, config);
	}

	/** @param {Types.GetAllUsersByServiceProviderParams} params */
	getAllUsersByServiceProvider(params, cache = false) {
		return this.http.get(`${this.path}/allUsersByServiceProvider`, {params, cache});
	}

	/** @param {Types.LoginServiceProviderParams} params */
	loginServiceProvider(params) {
		return this.http.post(`${this.path}/loginServiceProvider`, params);
	}

	/** @param {Types.GetUsersByServiceProviderParams} params */
	getUsersByServiceProvider(params, cache = false) {
		return this.http.get(`${this.path}/usersByServiceProvider`, {params, cache});
	}

	/** @param {Types.GetCapabilitiesParams} params */
	getCapabilities(params, cache = false) {
		return this.http.get(`${this.path}/capabilities`, {params, cache});
	}

	/** @param {Types.GetUserDetailsByIdParams} params */
	getUserDetailsById(params, cache = false) {
		return this.http.get(`${this.path}/userDetailsById`, {params, cache});
	}

	/** @param {Types.EnableUserParams} params */
	enableUser(params) {
		return this.http.post(`${this.path}/enable`, params);
	}

	/** @param {Types.DisableUserParams} params */
	disableUser(params) {
		return this.http.post(`${this.path}/disable`, params);
	}

	/** @param {Types.UpdateUserParams} params */
	updateUser(params) {
		return this.http.post(`${this.path}/updateUser`, params);
	}

	/** @param {Types.CreateUserParams} params */
	createUser(params) {
		return this.http.post(`${this.path}/createUser`, params);
	}

	/** @param {Types.GetAllFeaturesParams} params */
	getAllFeatures(params, cache = false) {
		return this.http.get(`${this.path}/allFeatures`, {params, cache});
	}

	/** @param {Types.PostAssignCommissionTierToUserParams} params */
	postAssignCommissionTierToUser(params) {
		return this.http.post(`${this.path}/assignCommissionTierToUser`, params);
	}

	/** @param {Types.PostUnAssignCommissionTierToUserParams} params */
	postUnAssignCommissionTierToUser(params) {
		return this.http.post(`${this.path}/unassignCommissionTierToUser`, params);
	}

	/** @param {Types.GetAllPermissionsParams} params */
	getAllPermissions(params, cache = false) {
		return this.http.get(`${this.path}/allPermissions`, {params, cache});
	}

	/** @param {Types.GetDetailsByTokenParams} params */
	getDetailsByToken(params, cache = true) {
		const headers = {Auth: this.PUBLIC_KEY};
		return this.http.get(`${this.path}/detailsByToken`, {params, cache, headers});
	}

	/** @param {Types.PostSavePasswordParams} params */
	postSavePassword(params) {
		const config = {headers: {Auth: this.PUBLIC_KEY}};
		return this.http.post(`${this.path}/savePassword`, params, config);
	}

	/** @param {Types.GetFeaturesParams} params */
	getFeatures(params, cache = false) {
		return this.http.get(`${this.path}/features`, {params, cache});
	}
}
//
let compMod = angular
	.module('mod.svc.ServiceProviderUser', [])
	.service('ServiceProviderUserService', ServiceProviderUser);
export default (compMod = compMod.name);
